import Vue from "vue";

import App from "./App";
import router from "./router";
import store from "./store/index";
import axios from "axios";

// Controls
import AppButton from "@/components/UI/controls/Button.vue";
import AppInput from "@/components/UI/controls/Input.vue";
import AppTextArea from "@/components/UI/controls/TextArea.vue";
import AppCheckbox from "@/components/UI/controls/Checkbox.vue";

// Constrols
Vue.component("AppButton", AppButton);
Vue.component("AppInput", AppInput);
Vue.component("AppTextArea", AppTextArea);
Vue.component("AppCheckbox", AppCheckbox);

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ru-RU";

import Buefy from "buefy";
Vue.use(Buefy, {
  defaultIconPack: "mdi"
});

import "element-ui/lib/theme-chalk/index.css";
import "ecligrid/ecligrid.min.css";

import moment from "moment";

import "./filters/filters";

// import VueAnalytics from 'vue-analytics'

Vue.use(moment, moment.locale("ru"));
Vue.use(ElementUI, {
  size: "small",
  // zIndex: 2005,
  locale
});
// Vue.use(VueAnalytics, {
//   id: 'UA-123276782-1',
//   router
// })

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});
